import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { NbIconModule } from '@nebular/theme';

import { ToastComponent } from '../core/classes';

@Component({
  selector: 'sui-base-toast',
  imports: [NbIconModule],
  templateUrl: './base-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseToastComponent extends ToastComponent implements OnInit, OnDestroy {
  ngOnInit() {
    this.setCommonData();
  }
}
